import { colors } from '@/theme/colors';
import type { HeaderCellConfig } from '@/ui/table/table.types';

export const companySuggestionsTableHeaders: HeaderCellConfig[] = [
  {
    columnKey: 'companies',
    bgColor: colors.basics.white,
    withSort: false,
  },
  {
    columnKey: 'tags',
    bgColor: colors.basics.white,
    withSort: false,
    minWidth: { lg: '12em', md: '10em' },
  },
  {
    columnKey: 'projects',
    bgColor: colors.basics.white,
    withSort: false,
    maxWidth: { lg: '8em', md: '8em' },
  },
  {
    columnKey: 'founded',
    bgColor: colors.basics.white,
    withSort: false,
    maxWidth: { lg: '7em', md: '7em' },
  },
  {
    columnKey: 'fundingStage',
    bgColor: colors.basics.white,
    withSort: false,
    maxWidth: { lg: '9em', md: '9em' },
  },
  {
    columnKey: 'capitalRaised',
    bgColor: colors.basics.white,
    withSort: false,
    maxWidth: { lg: '8em', md: '8em' },
  },
  {
    columnKey: 'lastModified',
    bgColor: colors.basics.white,
    withSort: false,
    maxWidth: { lg: '9em', md: '9em' },
  },
];
